module.exports = __webpack_public_path__ + "media/images/logo_patrimoine_rh-602115d60089545a0dcf3fd45357c311.png";